import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import DataTable from "../../Componentes/Utils/DataTable";
import { formatCurrency } from "../../Funcoes/formatCurrency";
import useApi from "../../hooks/useApi";
import { useModal } from "../../contexts/ModalContext";
import ModalParcelas from "./ModalParcelas";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useState } from "react";
import { useToast } from "../../contexts/ToastContext";

const Title = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: var(--ctrl-text, #333);
`;

const Subtitle = styled.p`
    margin: 0 0 12px 0;
    font-size: 14px;
    color: var(--ctrl-text-muted, #555);
`;

const TableWrapper = styled.div`
    width: 100%;
    max-height: 60dvh;
    overflow: auto;
    border: 1px solid var(--ctrl-border, #ddd);
    border-radius: 8px;
`;

const EmptyText = styled.p`
    margin: 0;
    font-size: 14px;
    color: var(--ctrl-text-muted, #666);
`;

const LoadingWrapper = styled.div`
    width: 100%;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Coluna = styled.td`
    text-align: ${({ align }) => align || "left"};
`;

const formatQuantidade = (value) => {
    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) return " - ";

    return numValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

const ModalItensPedidoResumo = ({ fecharModal, pedido, itens, loadingItens }) => {
    const api = useApi();
    const { notifyError } = useToast();
    const { isModalOpen, openModal, closeModal } = useModal();
    const [pdfLoading, setPdfLoading] = useState(false);
    const [parcelas, setParcelas] = useState([]);
    const [valorTotal, setValorTotal] = useState(0);
    const [consistencia, setConsistencia] = useState(null);

    const abrirParcelas = async () => {
        if (!pedido?.FILIAL || !pedido?.NUM_PEDIDO) return;

        setPdfLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("filial", pedido.FILIAL);
            params.append("num_pedido", pedido.NUM_PEDIDO);

            const { data } = await api.get(
                `Painel/API/Controladoria/CondicaoPagamento/index.php?${params.toString()}`
            );

            setParcelas(data.parcelas || []);
            setValorTotal(data.valor_total || 0);
            setConsistencia(data.consistencia || null);
            openModal("controladoria-parcelas");
        } catch (e) {
            notifyError(e?.response?.data?.message || "Erro ao carregar as parcelas do pedido.");
        } finally {
            setPdfLoading(false);
        }
    };

    return (
        <Overlay state={true}>
            <Modal size="lg" header close={fecharModal}>
                <Title>Itens do Pedido</Title>
                <Subtitle>
                    Pedido: <strong>{pedido?.NUM_PEDIDO}</strong> | Filial: <strong>{pedido?.FILIAL}</strong>
                </Subtitle>

                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
                    <button
                        type="button"
                        onClick={abrirParcelas}
                        disabled={pdfLoading || loadingItens}
                        style={{
                            height: 34,
                            padding: "0 14px",
                            border: "1.2px solid var(--ctrl-border, #d3d3d3)",
                            borderRadius: 4,
                            backgroundColor: pdfLoading || loadingItens ? "var(--ctrl-surface-muted, #f0f0f0)" : "transparent",
                            cursor: pdfLoading || loadingItens ? "not-allowed" : "pointer",
                            color: "var(--ctrl-text, #333)"
                        }}
                    >
                        {pdfLoading ? "Carregando..." : "Imprimir Pedido de Compra"}
                    </button>
                </div>

                {loadingItens ? (
                    <LoadingWrapper>
                        <SmallLoading text="Carregando itens do pedido..." />
                    </LoadingWrapper>
                ) : itens.length === 0 ? (
                    <EmptyText>Nenhum item encontrado para este pedido.</EmptyText>
                ) : (
                    <TableWrapper>
                        <DataTable>
                            <thead>
                                <tr>
                                    <th>NOME DO ITEM</th>
                                    <th>ITEM CONTA</th>
                                    <th>QUANTIDADE</th>
                                    <th>UNIDADE</th>
                                    <th>VALOR UNITÁRIO</th>
                                    <th>VALOR TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itens.map((item) => (
                                    <tr key={item.ID}>
                                        <td>{item.NOME_ITEM || " - "}</td>
                                        <td>{item.ITEM_CONTA || " - "}</td>
                                        <Coluna align="right">{formatQuantidade(item.QUANTIDADE)}</Coluna>
                                        <Coluna align="center">{item.UNIDADE || " - "}</Coluna>
                                        <Coluna align="right">
                                            {item.PRC_UNIT != null ? `R$ ${formatCurrency(item.PRC_UNIT)}` : " - "}
                                        </Coluna>
                                        <Coluna align="right">
                                            {item.VLR_TOTAL != null ? `R$ ${formatCurrency(item.VLR_TOTAL)}` : " - "}
                                        </Coluna>
                                    </tr>
                                ))}
                            </tbody>
                        </DataTable>
                    </TableWrapper>
                )}
            </Modal>

            {isModalOpen("controladoria-parcelas") && (
                <ModalParcelas
                    fecharModal={closeModal}
                    pedido={pedido}
                    valorTotal={valorTotal}
                    parcelas={parcelas}
                    consistencia={consistencia}
                />
            )}
        </Overlay>
    );
};

export default ModalItensPedidoResumo;
